import React from "react";
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import SubPage from 'components/pages/graphic-stands/sub-pages';


const GraphicStandRoute = ({ graphicPacking, graphicStand, history }) => {


    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` }>
                <SubPage.OverView
                    graphicPacking={ graphicPacking }
                    graphicStand={ graphicStand }
                    history={ history } />
            </Route>
        </Switch>
    );
};

export default GraphicStandRoute;
